"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureLabel_1 = require("./FeatureLabel");
exports.default = FeatureLabel_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/FeatureList/components/FeatureLabel/index.js
// module id = 1335
// module chunks = 8